<template>
  <div class="card shadow"
       :class="type === 'dark' ? 'bg-default': ''">
    <div class="card-header border-0"
         :class="type === 'dark' ? 'bg-transparent': ''">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0" :class="type === 'dark' ? 'text-white': ''">
            {{title}} <br><a href="https://docs.justwash.asia/tutorial/withdraw" style="color: #007aff; font-size: 14px;   font-weight: 400;" target="_blank">View tutorial</a>
          </h3>
        </div>
        <div class="col text-right">
          <base-button type="success" size="sm" @click="tableToExcel('table', 'Lorem Table')">Export</base-button>
        </div>
      </div>
    </div>

    <div class="table-responsive" ref="table" id="loremTable">
      <base-table class="table align-items-center table-flush"
                  :class="type === 'dark' ? 'table-dark': ''"
                  :thead-classes="type === 'dark' ? 'thead-dark': 'thead-light'"
                  tbody-classes="list"
                  :data="tableData">
        <template slot="columns">
          <th class="text-center" style="font-size: 14px;">Datetime</th>
          <th class="text-center" style="font-size: 14px;">From</th>
          <th class="text-center" style="font-size: 14px;">Amount (Bath)</th>
          <th class="text-center" style="font-size: 14px;">Status</th>
          <!-- <th></th> -->
        </template>

        <template slot-scope="{row}">
          <!-- <th scope="row">
            <div class="media align-items-center">
              <a href="#" class="avatar rounded-circle mr-3">
                <img alt="Image placeholder" :src="row.img">
              </a>
              <div class="media-body">
                <span class="name mb-0 text-sm">{{row.title}}</span>
              </div>
            </div>
          </th> -->
          <td class="text-center">
            {{row.creation}}
          </td>
          <td class="text-center">
            <!-- <div class="d-flex align-items-center">
              <span class="completion mr-2">{{row.completion}}%</span>
              <div>
                <base-progress :type="row.statusType"
                               :show-percentage="false"
                               class="pt-0"
                               :value="row.completion"/>
              </div>
            </div> -->
            From : {{row.transections_count}} Transections<br>
            Profit : {{row.profit}} บาท<br>
            Service Fee : {{row.prompt_service_change}} บาท
          </td>
          <!-- <td class="budget text-center">
            <b>{{row.profit-row.prompt_service_change}} บาท</b>
          </td> -->
          <td class="budget text-center">
            <b>{{row.amount}} บาท</b>
          </td>

          <td class="text-center">
            <badge class="badge-dot mr-4" :type="row.statusType">
              <i :class="`bg-${row.statusType}`"></i>
              <span class="status" >In Progress</span>
              <!-- <span class="status" v-else>ยังไม่ได้ดำเนินการ</span> -->
            </badge>
          </td>

          <!-- <td class="text-center">
            <base-dropdown class="dropdown"
                           position="right">
              <a slot="title" class="btn btn-sm btn-primary text-light" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="fas fa-ellipsis-v"></i>
              </a>

              <template>
                <a class="dropdown-item" href="#">Action</a>
                <a class="dropdown-item" href="#">Another action</a>
                <a class="dropdown-item" href="#">Something else here</a>
              </template>
            </base-dropdown>
          </td> -->

        </template>

      </base-table>
    </div>

    <div class="card-footer d-flex justify-content-end"
         :class="type === 'dark' ? 'bg-transparent': ''">
      <!-- <base-pagination total="30"></base-pagination> -->
    </div>

  </div>
</template>
<script>
  import DatePicker from 'vue2-datepicker';
  import 'vue2-datepicker/index.css';
  import 'vue2-datepicker/locale/th';
  import moment from 'moment';

  import JwService from '../../service/justwash';
  import apiService from '../../service/api';

  export default {
    components: { DatePicker },
    name: 'withdraw-table',
    props: {
      type: {
        type: String
      },
      title: String
    },
    data() {
      return {
        uri :'data:application/vnd.ms-excel;base64,',
        template:'<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
        base64: function(s){ return window.btoa(unescape(encodeURIComponent(s))) },
        format: function(s, c) { return s.replace(/{(\w+)}/g, function(m, p) { return c[p]; }) },
        tableData: null,
        status_changepass: false,

        
      }
    },
    methods:{
      tableToExcel(table, name) {
        if (!table.nodeType) table = this.$refs.table
        var ctx = {worksheet: name || 'Worksheet', table: table.innerHTML}
        window.location.href = this.uri + this.base64(this.format(this.template, ctx))
      }
    },
 async  mounted() {
      apiService.check();
       this.$isLoading(true)

      axios({
        method: 'post',
        url: JwService.getAPI()+'/api/method/justwash.OwnerApi.WithdrawStatements',
        data: {},
        headers: {
          'Authorization' : 'Token '+localStorage.getItem('accessToken')
        }
      }).then((response) => {
        if (response.data.message.status==true) {

           this.$isLoading(false)
          this.tableData = response.data.message.data
          for (const item of this.tableData ) {
            // console.log(new Date(item.creation));
            // console.log(moment(item.creation).format('YYYY-MM-DD'));

            item.creation = moment(item.creation).format('YYYY-MM-DD')


           item.amount += '';
           let x = item.amount.split('.');
           let x1 = x[0];
           let x2 = x.length > 1 ? '.' + x[1] : '';
           var rgx = /(\d+)(\d{3})/;
           while (rgx.test(x1)) {
            x1 = x1.replace(rgx, '$1' + ',' + '$2');
           }
           item.amount  = x1+x2;
          }
          // console.log(response.data.message.data);

          // for (let idx in  response.data.message.data) {
          //   console.log(idx)
          // }
          // console.log(this.tableData);
          // console.log(response.data.message.data);
        } else {
          this.$router.push('/login')
        }
      }).catch(error => {
        console.log(error)
        this.$router.push('/login')
      });
    }
  }
</script>
<style>
</style>
